import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  main: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)'
  },
  message: {
    backgroundColor: 'lightgrey',
    border: 'solid 1px grey',
    fontSize: 16,
    fontWeight: 400,
    padding: '5px 15px 5px 15px'
  }
})

// important - this does rely on the parent component having a position of relative or something, else the box will cover it's nearest positioned parent,
// and not necessarily the element you want
export default function GlassPanel (props) {
  const {
    message = ''
  } = props

  const classes = useStyles()

  return (
    <Box className={classes.main} display="flex" justifyContent="center">
      <Box display="flex" alignItems="center">
        {
          message !== '' &&
          <Box className={classes.message}>
            {message}
          </Box>
        }
      </Box>
    </Box>
  )
}

GlassPanel.propTypes = {
  message: PropTypes.string
}
